export const companyDetails = {
  name: 'Blackhorse Mills',
  gymId: '5fd7cff72eb93d371e0aa7de'
};
